import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../../../services/common.service";
import { AppConfig } from "../../../../configs/app";

@Component({
	selector: 'page-info-pay-index',
	templateUrl: './index.component.html',
})
export class PageInfoPayIndexComponent implements OnInit {

    public $: any;

	constructor(
        public commonService: CommonService,
        public appConfig: AppConfig
    ) {
        this.$ = this.commonService.getJQuery();
	}

	async ngOnInit() {

        /* SET PAGE TITLE */
        this.commonService.setTitle(`お支払い方法 | バスブックマーク`);

		/* EXECUTE INLINE JAVASCRIPT */
        this.inlineJS();
    }

    inlineJS() {
        let self = this;

        self.$(document).ready(function () {
            // Scroll to the anchor if the URL contains a hash
            const hash = window.location.hash;
            if (hash) {
                const target = self.$(hash);
                if (target.length) {
                    const position = target.offset().top;
                    self.$('html, body').animate({ scrollTop: position }, 400, 'swing');
                }
            }

            self.$('a[href^="#"]').on('click', function (e: any) {
                const speed = 400;
                const href = self.$(this).attr('href');
                const target = href === '#' || href === '' ? 'html' : href;
                const position = self.$(target).offset().top;

                // Update the browser's URL without reloading the page
                if (href !== '#' && href !== '') {
                    const currentPath = window.location.pathname;
                    history.pushState(null, '', `${currentPath}${href}`);
                }

                self.$('html, body').animate({ scrollTop: position }, speed, 'swing');
                e.preventDefault();
            });
        });
    }

}
